import { configureStore } from '@reduxjs/toolkit';
import sessionReducer from './session';
import cacheReducer from './cache';

export const store = configureStore({
    reducer: {
        session: sessionReducer,
        cache: cacheReducer,
    },
});